import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock,
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaYoutube,
  FaWhatsapp,
  FaCheckCircle
} from 'react-icons/fa';
import './Contact.css';
import { Helmet } from 'react-helmet';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    program: '',
    message: ''
  });

  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Prepare data for Web3Forms
    const submissionData = new FormData();
    submissionData.append("access_key", "e7eec8a4-d57e-4709-81a3-1a0f141655ee");
    submissionData.append("name", formData.name);
    submissionData.append("email", formData.email);
    submissionData.append("phone", formData.phone);
    submissionData.append("subject", formData.subject);
    submissionData.append("program", formData.program);
    submissionData.append("message", formData.message);

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: submissionData
      });

      const data = await response.json();

      if (data.success) {
        // Show success message
        setIsSubmitted(true);
        // Clear form
        setFormData({
          name: '',
          email: '',
          phone: '',
          subject: '',
          program: '',
          message: ''
        });
        // Hide message after 5 seconds
        setTimeout(() => setIsSubmitted(false), 5000);
      } else {
        alert("Something went wrong! Please try again.");
      }
    } catch (error) {
      console.error(error);
      alert("Error submitting form. Please try again later.");
    }
  };

  const contactInfo = [
    { icon: <FaMapMarkerAlt />, title: 'Visit Us', details: ['Rani Talab, Jind, Haryana 126102'] },
    { icon: <FaPhone />, title: 'Call Us', details: ['+91 9728154227'] },
    { icon: <FaEnvelope />, title: 'Email Us', details: ['info@imperialbadminton.com'] },
    { icon: <FaClock />, title: 'Working Hours', details: ['Mon - Sat: 6:00 AM - 10:00 PM', 'Sunday: 7:00 AM - 8:00 PM'] },
  ];

  return (
    <>
      <Helmet>
        <title>Contact</title>
      </Helmet>

      <div className="contact-page">
        <div className="page-header">
          <div className="container">
            <h1>Contact Us</h1>
            <div className="breadcrumb">
              <Link to="/">Home</Link>
              <span>/</span>
              <span>Contact Us</span>
            </div>
          </div>
        </div>

        <section className="contact-main section">
          <div className="container">
            <div className="contact-layout">
              {/* Contact Form */}
              <div className="contact-form-wrapper">
                <div className="form-header">
                  <span className="section-subtitle">Get In Touch</span>
                  <h2>Send Us a Message</h2>
                  <p>
                    Have questions about our programs? Want to schedule a trial session?
                    Fill out the form below and we'll get back to you shortly.
                  </p>
                </div>

                {isSubmitted ? (
                  <div className="success-message">
                    <FaCheckCircle size={50} color="#28a745" />
                    <h3>Thank You!</h3>
                    <p>Your message has been sent successfully. We'll get back to you within 24 hours.</p>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit}>
                    <div className="form-row">
                      <div className="form-group">
                        <label htmlFor="name">Full Name *</label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          placeholder="Enter your full name"
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="email">Email Address *</label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="Enter your email"
                          required
                        />
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <label htmlFor="phone">Phone Number *</label>
                        <input
                          type="tel"
                          id="phone"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          placeholder="Enter your phone number"
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="subject">Subject *</label>
                        <select
                          id="subject"
                          name="subject"
                          value={formData.subject}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Select a subject</option>
                          <option value="general">General Inquiry</option>
                          <option value="admission">Admission Query</option>
                          <option value="trial">Book Trial Session</option>
                          <option value="fees">Fee Structure</option>
                          <option value="court">Court Booking</option>
                          <option value="event">Event Hosting</option>
                          <option value="feedback">Feedback</option>
                          <option value="other">Other</option>
                        </select>
                      </div>
                    </div>

                    <div className="form-group">
                      <label htmlFor="program">Interested Program</label>
                      <select
                        id="program"
                        name="program"
                        value={formData.program}
                        onChange={handleChange}
                      >
                        <option value="">Select a program (optional)</option>
                        <option value="beginner">Beginner Training</option>
                        <option value="intermediate">Intermediate Coaching</option>
                        <option value="advanced">Advanced Training</option>
                        <option value="professional">Professional Coaching</option>
                        <option value="kids">Kids Program (5-8 years)</option>
                        <option value="junior">Junior Program (9-14 years)</option>
                        <option value="recreational">Recreational/Weekend</option>
                      </select>
                    </div>

                    <div className="form-group">
                      <label htmlFor="message">Your Message *</label>
                      <textarea
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        placeholder="Tell us how we can help you..."
                        rows="5"
                        required
                      ></textarea>
                    </div>

                    <button type="submit" className="btn btn-primary btn-submit">
                      Send Message
                    </button>
                  </form>
                )}
              </div>

              {/* Contact Info */}
              <div className="contact-info-wrapper">
                <div className="contact-info-cards">
                  {contactInfo.map((info, index) => (
                    <div key={index} className="contact-info-card">
                      <div className="info-icon">{info.icon}</div>
                      <div className="info-content">
                        <h4>{info.title}</h4>
                        {info.details.map((detail, idx) => (
                          <p key={idx}>{detail}</p>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>

                {/* Social Links */}
                <div className="social-connect">
                  <h4>Connect With Us</h4>
                  <p>Follow us on social media for updates, tips, and behind-the-scenes content.</p>
                  <div className="social-links">
                    <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                      <FaFacebookF />
                    </a>
                    <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                      <FaTwitter />
                    </a>
                    <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                      <FaInstagram />
                    </a>
                    <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                      <FaYoutube />
                    </a>
                    <a href="https://wa.me/919876543210" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                      <FaWhatsapp />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Contact;
